var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _rect, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 550,
    viewBox: "0 0 656 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655.755 -4H0.361572V550.57H655.755V-4Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.237 209.2H266.779V211.657H271.695V206.742H269.237V209.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.915 209.199H249.526V211.657H256.915V209.199Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.411 209.199H8.02148V211.657H15.411V209.199Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.417 209.199H215.028V211.657H222.417V209.199Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.662 209.199H232.273V211.657H239.662V209.199Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 209.199H111.525V211.657H118.914V209.199Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6562 209.199H25.2666V211.657H32.6562V209.199Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9093 209.199H42.5198V211.657H49.9093V209.199Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.911 209.199H180.521V211.657H187.911V209.199Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.666 209.199H163.276V211.657H170.666V209.199Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4076 209.199H77.0181V211.657H84.4076V209.199Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.164 209.199H197.774V211.657H205.164V209.199Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1625 209.199H59.7729V211.657H67.1625V209.199Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.412 209.199H146.023V211.657H153.412V209.199Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.159 209.199H128.77V211.657H136.159V209.199Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.661 209.199H94.2712V211.657H101.661V209.199Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 66.1599H269.237V73.6887H271.695V66.1599Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 101.305H269.237V108.834H271.695V101.305Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 83.7329H269.237V91.2617H271.695V83.7329Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 118.878H269.237V126.407H271.695V118.878Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 136.451H269.237V143.98H271.695V136.451Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 13.4419H269.237V20.9707H271.695V13.4419Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 31.0146H269.237V38.5435H271.695V31.0146Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 48.5869H269.237V56.1157H271.695V48.5869Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 189.169H269.237V196.698H271.695V189.169Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 171.597H269.237V179.126H271.695V171.597Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 -4H269.237V3.39776H271.695V-4Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M271.695 154.023H269.237V161.552H271.695V154.023Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M571.308 209.199H563.918V211.657H571.308V209.199Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M519.556 209.199H512.167V211.657H519.556V209.199Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M554.055 209.199H546.665V211.657H554.055V209.199Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M536.801 209.199H529.412V211.657H536.801V209.199Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M502.303 209.199H494.913V211.657H502.303V209.199Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M485.05 209.199H477.66V211.657H485.05V209.199Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M450.551 209.199H443.162V211.657H450.551V209.199Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M467.797 209.199H460.407V211.657H467.797V209.199Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M433.298 209.199H425.909V211.657H433.298V209.199Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M416.045 209.199H408.655V211.657H416.045V209.199Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M605.806 209.199H598.416V211.657H605.806V209.199Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M588.553 209.199H581.163V211.657H588.553V209.199Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M623.059 209.199H615.67V211.657H623.059V209.199Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M640.304 209.199H632.915V211.657H640.304V209.199Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M655.755 209.199H650.168V211.657H655.755V209.199Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M393.885 211.657H398.8V209.2H396.342V206.742H393.885V211.657Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 31.0146H393.885V38.5435H396.342V31.0146Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 136.451H393.885V143.98H396.342V136.451Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 118.878H393.885V126.407H396.342V118.878Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 101.305H393.885V108.834H396.342V101.305Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 66.1599H393.885V73.6887H396.342V66.1599Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 83.7329H393.885V91.2617H396.342V83.7329Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 189.169H393.885V196.698H396.342V189.169Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 154.023H393.885V161.552H396.342V154.023Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 -4H393.885V3.39776H396.342V-4Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 13.4419H393.885V20.9707H396.342V13.4419Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 48.5869H393.885V56.1157H396.342V48.5869Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M396.342 171.597H393.885V179.126H396.342V171.597Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M542.774 497.581H535.384V500.039H542.774V497.581Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M577.28 497.581H569.89V500.039H577.28V497.581Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M560.027 497.581H552.637V500.039H560.027V497.581Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M525.52 497.581H518.131V500.039H525.52V497.581Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M491.022 497.581H483.632V500.039H491.022V497.581Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M473.769 497.581H466.379V500.039H473.769V497.581Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M456.524 497.581H449.134V500.039H456.524V497.581Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M422.017 497.581H414.628V500.039H422.017V497.581Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M594.525 497.581H587.135V500.039H594.525V497.581Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M508.275 497.581H500.886V500.039H508.275V497.581Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M439.27 497.581H431.881V500.039H439.27V497.581Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M646.277 497.581H638.887V500.039H646.277V497.581Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M404.772 497.581H397.383V500.039H404.772V497.581Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M335.767 497.581H328.378V500.039H335.767V497.581Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M629.031 497.581H621.642V500.039H629.031V497.581Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M611.778 497.581H604.389V500.039H611.778V497.581Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M353.021 497.581H345.631V500.039H353.021V497.581Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M370.266 497.581H362.876V500.039H370.266V497.581Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M387.519 497.581H380.129V500.039H387.519V497.581Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M313.607 500.039H318.522V497.581H316.065V495.124H313.607V500.039Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 231.532H313.607V239.061H316.065V231.532Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 213.959H313.607V221.488H316.065V213.959Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 284.25H313.607V291.779H316.065V284.25Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 266.677H313.607V274.206H316.065V266.677Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 178.814H313.607V186.343H316.065V178.814Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 161.241H313.607V168.77H316.065V161.241Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 196.387H313.607V203.916H316.065V196.387Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 126.096H313.607V133.625H316.065V126.096Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 301.823H313.607V309.352H316.065V301.823Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 143.668H313.607V151.197H316.065V143.668Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 442.405H313.607V449.934H316.065V442.405Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 424.832H313.607V432.361H316.065V424.832Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 319.396H313.607V326.925H316.065V319.396Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 459.978H313.607V467.507H316.065V459.978Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 407.26H313.607V414.789H316.065V407.26Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 477.551H313.607V485.079H316.065V477.551Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 336.969H313.607V344.498H316.065V336.969Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 354.541H313.607V362.07H316.065V354.541Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 372.114H313.607V379.643H316.065V372.114Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 389.687H313.607V397.216H316.065V389.687Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M316.065 249.105H313.607V256.634H316.065V249.105Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M318.522 111.145H313.607V116.06H316.065V113.603H318.522V111.145Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M353.021 111.145H345.631V113.603H353.021V111.145Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M335.767 111.145H328.378V113.603H335.767V111.145Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M646.277 111.145H638.887V113.603H646.277V111.145Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M422.017 111.145H414.628V113.603H422.017V111.145Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M370.266 111.145H362.876V113.603H370.266V111.145Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M404.772 111.145H397.383V113.603H404.772V111.145Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M629.031 111.145H621.642V113.603H629.031V111.145Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M387.519 111.145H380.129V113.603H387.519V111.145Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M439.27 111.145H431.881V113.603H439.27V111.145Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M473.769 111.145H466.379V113.603H473.769V111.145Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M508.275 111.145H500.886V113.603H508.275V111.145Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M491.022 111.145H483.632V113.603H491.022V111.145Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M577.272 111.145H569.882V113.603H577.272V111.145Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M594.525 111.145H587.135V113.603H594.525V111.145Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M560.027 111.145H552.637V113.603H560.027V111.145Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M525.52 111.145H518.131V113.603H525.52V111.145Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M456.524 111.145H449.134V113.603H456.524V111.145Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M611.778 111.145H604.389V113.603H611.778V111.145Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M542.774 111.145H535.384V113.603H542.774V111.145Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M130.777 441.135H123.387V443.593H130.777V441.135Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M113.523 441.135H106.134V443.593H113.523V441.135Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2737 441.135H19.8842V443.593H27.2737V441.135Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2785 441.135H88.8889V443.593H96.2785V441.135Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0204 441.135H2.63086V443.593H10.0204V441.135Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5269 441.135H37.1373V443.593H44.5269V441.135Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0252 441.135H71.6356V443.593H79.0252V441.135Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M61.772 441.135H54.3824V443.593H61.772V441.135Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M148.03 441.135H140.64V443.593H148.03V441.135Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M199.781 441.135H192.392V443.593H199.781V441.135Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M182.528 441.135H175.139V443.593H182.528V441.135Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M165.275 441.135H157.885V443.593H165.275V441.135Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M214.552 441.135H209.645V443.593H212.095V446.051H214.552V441.135Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M214.561 508.813H212.103V516.342H214.561V508.813Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M214.561 543.958H212.103V550.578H214.561V543.958Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M214.561 473.667H212.103V481.196H214.561V473.667Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M214.561 456.095H212.103V463.623H214.561V456.095Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M214.561 491.232H212.103V498.761H214.561V491.232Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M214.561 526.386H212.103V533.914H214.561V526.386Z",
    fill: "white"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M486.074 225.396H170.043C159.822 225.396 151.536 233.681 151.536 243.902V459.682C151.536 469.903 159.822 478.189 170.043 478.189H486.074C496.295 478.189 504.58 469.903 504.58 459.682V243.902C504.58 233.681 496.295 225.396 486.074 225.396Z",
    fill: "#989999"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M151.536 428.503V459.691C151.536 464.599 153.486 469.307 156.957 472.777C160.427 476.248 165.135 478.198 170.043 478.198H486.074C490.982 478.198 495.689 476.248 499.16 472.777C502.631 469.307 504.58 464.599 504.58 459.691V428.503H151.536Z",
    fill: "#313533"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M492.448 236.726H163.677V428.502H492.448V236.726Z",
    fill: "#85DAD7"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M358.854 478.19H297.263L280.878 544.548H375.239L358.854 478.19Z",
    fill: "#989999"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M403.183 544.548C403.183 546.147 402.548 547.681 401.417 548.811C400.286 549.942 398.752 550.577 397.153 550.577H258.963C257.364 550.577 255.831 549.942 254.7 548.811C253.569 547.681 252.934 546.147 252.934 544.548C252.933 543.756 253.088 542.971 253.391 542.239C253.693 541.507 254.137 540.842 254.697 540.282C255.258 539.722 255.923 539.278 256.655 538.975C257.387 538.672 258.171 538.517 258.963 538.518H397.153C397.945 538.517 398.73 538.672 399.462 538.975C400.194 539.278 400.859 539.722 401.419 540.282C401.979 540.842 402.423 541.507 402.726 542.239C403.029 542.971 403.184 543.756 403.183 544.548Z",
    fill: "#313533"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M307.323 383.231V386.918H303.637",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M293.306 386.917H189.951",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.46 12.62"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M184.789 386.918H181.103V383.231",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M181.103 372.696V267.333",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.65 12.86"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M181.103 262.065V258.378H184.789",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M195.12 258.378H298.476",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.46 12.62"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M303.637 258.378H307.323V262.065",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M307.323 272.601V377.963",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.65 12.86"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M475.014 383.231V386.918H471.327",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M460.997 386.917H357.641",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.46 12.62"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M352.48 386.918H348.793V383.231",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M348.785 372.696V267.333",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.65 12.86"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M348.793 262.065V258.378H352.48",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M362.811 258.378H466.166",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.46 12.62"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M471.327 258.378H475.014V262.065",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M475.014 272.601V377.963",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9.65 12.86"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M107.338 147.314H115.981H129.278H137.929H151.217H159.868H173.164H181.816H195.104H202.444H230.446L212.726 137.032L209.793 135.328L201.477 130.503H198.626H193.989H182.93H178.293H176.679H172.05H160.982H156.354H154.74H150.103H139.043H134.414H132.8H128.163H117.104H112.467H110.853H106.216H102.497L100.989 124.252H201.477L241.211 147.314V153.565H108.092L106.576 147.314H107.338Z",
    fill: "#666666"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M61.559 124.252V130.503H51.2775H46.6406H45.0267H40.3898H29.33H24.6931H22.9973V147.314H23.5789H28.2158H41.5121H50.1552H61.559V153.565H16.7465V151.623V147.314V130.503V127.382V124.252H61.559Z",
    fill: "#666666"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7874 121.131H90.1505L78.4353 109.408L68.9894 121.131H66.4744V119.017L76.1005 107.081L66.4744 97.4549V94.2107H67.8671L78.1731 104.517L86.4803 94.2107H88.6431L89.11 96.1605L80.4998 106.843L94.7874 121.131Z",
    fill: "#666666"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M209.793 135.329L198.774 146.347L190.778 138.352L198.626 130.503H193.989L188.46 136.033L182.93 130.503H178.293L186.141 138.352L177.49 147.003L168.83 138.352L176.679 130.503H172.05L166.52 136.033L160.982 130.503H156.353L164.202 138.352L155.542 147.003L146.891 138.352L154.74 130.503H150.103L144.548 136.033L139.018 130.503H134.381L142.23 138.352L133.578 147.003L124.927 138.352L132.776 130.503H128.163L122.633 136.033L117.104 130.503H112.467L120.315 138.352L111.664 147.003L104.848 140.187L104.127 137.213L110.853 130.495H106.216L103.226 133.485L102.496 130.495L100.989 124.244L92.5017 89.2871H61.5671V131.265L56.8073 136.025L51.2692 130.495H46.6405L54.4889 138.343L45.8295 147.003L37.1783 138.352L45.0266 130.503H40.3897L34.8598 136.033L29.3299 130.503H24.693L32.5414 138.352L23.5789 147.314H28.2158L34.8598 140.67L41.5039 147.314H50.1551L56.8073 140.67L61.5671 145.43V159.218H90.1832L81.9089 167.492L74.0933 159.644V164.281L79.6232 169.81L74.0933 175.34V179.977L81.9089 172.137L90.5601 180.788L81.9089 189.439L74.0933 181.591V186.22L79.6232 191.75L74.0933 197.28V201.917L81.9417 194.068L90.5929 202.728L81.9089 211.379L74.0933 203.53V208.184L79.6232 213.714L74.0933 219.227V223.864L81.9417 216.016L90.5929 224.667L81.9089 233.326L74.0933 225.478V230.107L79.6232 235.637L74.0933 241.166V245.803L81.9417 237.955L90.5929 246.614L81.9089 255.266L74.0933 247.417V252.054L79.6232 257.584L74.0933 263.114V267.743L81.9417 259.902L90.5929 268.554L81.9089 277.205L74.0933 269.357V273.993L79.6232 279.523L74.0933 285.053V289.69L81.9417 281.842L90.5929 290.493L81.9089 299.12L74.0933 291.304V295.933L79.6232 301.471L74.0933 307.001V311.629L81.9417 303.781L90.5929 312.44L81.9089 321.092L74.0933 313.243V317.88L79.6232 323.41L74.0933 328.94V333.577L81.9417 325.729L90.5601 334.347L81.9089 343.039L74.0933 335.166V339.795L79.6232 345.325L74.0933 350.879V355.516L81.9417 347.668L90.5929 356.327L81.9089 364.978L74.0933 357.13V361.767L79.6232 367.297L74.0933 372.851V377.48L81.9417 369.64L90.5929 378.291L81.9089 386.918L74.0933 379.078V383.706L79.5904 389.236L74.0933 394.766V399.403L81.9417 391.555L90.5929 400.206L81.9089 408.898L74.0933 401.017V405.621L79.6232 411.151L74.0933 416.714V421.342L81.9417 413.502L90.5929 422.153L81.9089 430.805L74.0933 422.956V427.593L79.6232 433.123L74.0933 438.653V443.306L81.9417 435.458L90.5601 444.125L81.9089 452.752L74.0933 444.945V449.573L79.6232 455.111L74.0933 460.6V465.229L81.9417 457.381L90.5929 466.04L81.9089 474.691L74.0933 466.843V471.48L79.6232 477.01L74.0933 482.54V487.168L81.9089 479.353L90.5601 488.004L81.9089 496.639L74.0933 488.791V493.419L79.6232 498.949L74.0933 504.479V509.116L81.9417 501.268L90.5929 509.919L81.9089 518.578L74.0933 510.73V515.399L79.6232 520.929L74.0933 526.427V531.055L81.9417 523.215L90.5601 531.866L81.9089 540.517L74.0933 532.669V537.306L79.6232 542.836L74.0933 548.366V550.152H76.9443L81.9417 545.154L86.9308 550.152H90.9042V549.48L84.2519 542.836L90.9042 536.192V527.541L84.2519 520.897L90.9042 514.253V505.569L84.2519 498.916L90.9042 492.272V483.654L84.2519 477.01L90.9042 470.366V461.715L84.2519 455.07L90.9042 448.418V439.767L84.2519 433.123L90.9042 426.479V417.828L84.2519 411.184L90.9042 404.531V395.888L84.2192 389.236L90.8714 382.592V373.941L84.2192 367.297L90.8714 360.653V352.002L84.2192 345.349L90.8714 338.705V330.054L84.2192 323.41L90.8714 316.766V308.131L84.2192 301.487L90.8714 294.835V290.886H93.2554L91.7152 289.354L90.896 290.173V286.151L84.2437 279.507L90.896 272.863V264.228L84.2437 257.584L90.896 250.94V242.289L84.2437 235.637L90.896 228.992V220.341L84.2437 213.697L90.896 207.053V198.402L84.2437 191.75L90.896 185.106V176.454L84.2437 169.81L90.896 163.166V159.218H109.493L108.116 153.565L106.601 147.314L106.363 146.315L107.363 147.314H116.006L122.658 140.67L129.302 147.314H137.953L144.597 140.67L151.241 147.314H159.868L166.52 140.67L173.164 147.314H181.815L188.46 140.67L195.104 147.314H202.477L212.758 137.033L209.793 135.329ZM61.5671 140.793L59.1094 138.335L61.5671 135.877V140.793ZM82.9821 152.074C80.8044 152.074 78.6756 151.428 76.8649 150.218C75.0542 149.008 73.643 147.289 72.8096 145.277C71.9763 143.265 71.7582 141.051 72.183 138.915C72.6079 136.779 73.6566 134.817 75.1964 133.278C76.7363 131.738 78.6982 130.689 80.834 130.264C82.9699 129.839 85.1837 130.057 87.1957 130.891C89.2076 131.724 90.9272 133.135 92.1371 134.946C93.347 136.757 93.9927 138.886 93.9927 141.063C93.9938 142.509 93.7097 143.942 93.1568 145.278C92.6038 146.614 91.7928 147.829 90.7702 148.851C89.7475 149.874 88.5333 150.685 87.1969 151.238C85.8606 151.791 84.4283 152.075 82.9821 152.074ZM66.4826 121.131V94.2107H88.6431L89.11 96.1605L95.1724 121.131H66.4826Z",
    fill: "#4B4B4B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9822 152.074C89.0632 152.074 93.9928 147.144 93.9928 141.063C93.9928 134.982 89.0632 130.052 82.9822 130.052C76.9012 130.052 71.9716 134.982 71.9716 141.063C71.9716 147.144 76.9012 152.074 82.9822 152.074Z",
    fill: "#666666"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0934 550.152V159.218H67.8098V550.152H74.0934ZM72.1272 289.338L73.6592 290.87H70.5625L72.1272 289.338Z",
    fill: "#666666"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0944 289.338L73.6263 290.87H70.5624L72.0944 289.338Z",
    fill: "#4B4B4B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1141 550.143V159.218H90.8715V290.19L91.7235 289.338L93.2555 290.87H90.8715V550.143H97.1141Z",
    fill: "#666666"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M134.062 248.793L186.141 216.671L238.229 248.793H134.062Z",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M179.407 211.584C179.405 212.918 179.799 214.223 180.54 215.333C181.28 216.443 182.333 217.308 183.565 217.819C184.798 218.331 186.154 218.465 187.463 218.205C188.771 217.945 189.973 217.303 190.917 216.359C191.86 215.416 192.503 214.214 192.762 212.905C193.022 211.597 192.888 210.24 192.377 209.008C191.865 207.776 191 206.723 189.89 205.982C188.78 205.242 187.475 204.848 186.141 204.85V199.729",
    stroke: "#666666",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M190.778 197.829H181.512V201.63H190.778V197.829Z",
    fill: "#4B4B4B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M194.432 194.027H177.859V197.829H194.432V194.027Z",
    fill: "#4B4B4B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M190.778 156.547H181.512V160.348H190.778V156.547Z",
    fill: "#4B4B4B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M194.432 152.754H177.859V156.555H194.432V152.754Z",
    fill: "#4B4B4B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M188.46 160.348H183.872V194.027H188.46V160.348Z",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    x: 117.669,
    y: 255.216,
    width: 137.239,
    height: 116.005,
    fill: "url(#pattern0_2157_8690)"
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M245.225 239.651H127.066C125.948 239.651 125.042 240.557 125.042 241.674V338.533C125.042 339.651 125.948 340.557 127.066 340.557H245.225C246.342 340.557 247.248 339.651 247.248 338.533V241.674C247.248 240.557 246.342 239.651 245.225 239.651Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M125.042 315.078V338.533C125.042 339.069 125.254 339.582 125.632 339.961C126.009 340.341 126.522 340.555 127.057 340.557H245.225C245.761 340.555 246.274 340.341 246.653 339.962C247.032 339.583 247.246 339.069 247.248 338.533V315.078H125.042Z",
    fill: "#CFD1D9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M247.248 248.146V241.674C247.246 241.138 247.032 240.625 246.653 240.246C246.274 239.867 245.761 239.653 245.225 239.651H127.057C126.522 239.653 126.009 239.867 125.632 240.246C125.254 240.626 125.042 241.139 125.042 241.674V248.146H247.248Z",
    fill: "#666666"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M129.564 245.984C130.718 245.984 131.653 245.048 131.653 243.894C131.653 242.741 130.718 241.805 129.564 241.805C128.411 241.805 127.475 242.741 127.475 243.894C127.475 245.048 128.411 245.984 129.564 245.984Z",
    fill: "#C1272D"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M136.675 245.984C137.829 245.984 138.764 245.048 138.764 243.894C138.764 242.741 137.829 241.805 136.675 241.805C135.521 241.805 134.586 242.741 134.586 243.894C134.586 245.048 135.521 245.984 136.675 245.984Z",
    fill: "#FBB03B"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M143.786 245.984C144.94 245.984 145.875 245.048 145.875 243.894C145.875 242.741 144.94 241.805 143.786 241.805C142.633 241.805 141.697 242.741 141.697 243.894C141.697 245.048 142.633 245.984 143.786 245.984Z",
    fill: "#8CC63F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M247.248 248.146H125.042V260.345H247.248V248.146Z",
    fill: "#CFD1D9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M165.554 251.243H134.938V257.699H165.554V251.243Z",
    fill: "#446B34"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M201.453 251.243H170.838V257.699H201.453V251.243Z",
    fill: "#FFBD4F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M237.344 251.243H206.729V257.699H237.344V251.243Z",
    fill: "#9C9E4C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M199.716 278.311C199.711 280.995 198.911 283.617 197.416 285.846C195.922 288.075 193.8 289.811 191.319 290.835C188.838 291.858 186.109 292.124 183.478 291.597C180.846 291.071 178.43 289.776 176.534 287.876C174.638 285.977 173.347 283.558 172.825 280.926C172.304 278.293 172.574 275.565 173.602 273.086C174.63 270.607 176.37 268.488 178.602 266.997C180.834 265.507 183.457 264.711 186.141 264.711C187.926 264.711 189.693 265.063 191.342 265.747C192.99 266.431 194.488 267.433 195.749 268.696C197.01 269.959 198.009 271.459 198.69 273.108C199.37 274.758 199.719 276.526 199.716 278.311Z",
    fill: "#76ABD5"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M237.344 296.432C237.344 296.732 237.225 297.02 237.013 297.232C236.801 297.444 236.513 297.563 236.213 297.563H136.069C135.769 297.563 135.482 297.444 135.27 297.232C135.058 297.02 134.938 296.732 134.938 296.432C134.938 296.132 135.058 295.845 135.27 295.633C135.482 295.421 135.769 295.302 136.069 295.302H236.213C236.513 295.302 236.801 295.421 237.013 295.633C237.225 295.845 237.344 296.132 237.344 296.432Z",
    fill: "#AEB8BF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M237.344 302.036C237.344 302.336 237.225 302.624 237.013 302.836C236.801 303.048 236.513 303.167 236.213 303.167H136.069C135.769 303.167 135.482 303.048 135.27 302.836C135.058 302.624 134.938 302.336 134.938 302.036C134.938 301.736 135.058 301.449 135.27 301.237C135.482 301.025 135.769 300.906 136.069 300.906H236.213C236.513 300.906 236.801 301.025 237.013 301.237C237.225 301.449 237.344 301.736 237.344 302.036Z",
    fill: "#AEB8BF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M237.344 307.64C237.345 307.789 237.316 307.937 237.26 308.075C237.204 308.213 237.121 308.338 237.016 308.444C236.91 308.55 236.785 308.634 236.648 308.691C236.51 308.749 236.362 308.778 236.213 308.778H136.069C135.92 308.778 135.772 308.749 135.635 308.691C135.497 308.634 135.372 308.55 135.267 308.444C135.162 308.338 135.079 308.213 135.022 308.075C134.966 307.937 134.937 307.789 134.939 307.64C134.939 307.34 135.058 307.052 135.27 306.84C135.482 306.628 135.769 306.509 136.069 306.509H236.213C236.513 306.509 236.801 306.628 237.013 306.84C237.225 307.052 237.344 307.34 237.344 307.64Z",
    fill: "#AEB8BF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M237.344 319.797H134.938V335.969H237.344V319.797Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M509.119 70.3136H500.468H487.172H478.52H465.232H456.581H443.285H434.634H421.345H414.005H386.003L403.724 60.0321L406.656 58.3281L414.972 53.5028H417.823H422.46H433.519H438.156H439.77H444.399H455.467H460.096H461.71H466.346H477.406H482.043H483.657H488.286H499.354H503.982H505.596H510.233H513.953L515.468 47.252H414.972L375.239 70.3136V76.5644H508.357L509.873 70.3136H509.119Z",
    fill: "#666666"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M554.89 47.252V53.5028H565.18H569.809H571.422H576.059H587.119H591.756H593.46V70.3136H592.87H588.233H574.945H566.294H554.89V76.5644H599.703V74.6228V70.3136V53.5028V50.3815V47.252H554.89Z",
    fill: "#666666"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M521.662 44.1305H526.299L538.014 32.4153L547.468 44.1305H549.975V42.0169L540.349 30.0805L549.975 20.4544V17.2102H548.582L538.276 27.5163L529.977 17.2102H527.814L527.339 19.16L535.949 29.8429L521.662 44.1305Z",
    fill: "#666666"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M554.89 68.4291L559.65 63.6693L566.294 70.3134H574.945L581.589 63.6693L588.233 70.3134H592.87L583.908 61.3509L591.756 53.5026H587.119L581.589 59.0324L576.059 53.5026H571.422L579.271 61.3509L570.62 70.0021L561.96 61.3509L569.809 53.5026H565.18L559.65 59.0324L554.89 54.2726V12.2947H523.947L515.468 47.2517L513.953 53.5026L513.207 56.4928L510.217 53.5026H505.58L512.306 60.2285L511.569 63.1778L504.761 69.9857L496.134 61.3509L503.982 53.5026H499.354L493.816 59.0324L488.286 53.5026H483.657L491.505 61.3509L482.846 70.0021L474.195 61.3509L482.076 53.5026H477.406L471.876 59.0324L466.346 53.5026H461.71L469.558 61.3509L460.907 70.0021L452.247 61.3509L460.096 53.5026H455.467L449.937 59.0324L444.391 53.5026H439.762L447.61 61.3509L438.959 70.0021L430.308 61.3509L438.156 53.5026H433.519L428.006 59.0324L422.476 53.5026H417.847L425.687 61.3509L417.692 69.3467L406.656 58.3279L403.724 60.0319L414.005 70.3134H421.378L428.006 63.6693L434.65 70.3134H443.301L449.953 63.6693L456.597 70.3134H465.249L471.893 63.6693L478.537 70.3134H487.188L493.832 63.6693L500.484 70.3134H509.111L510.11 69.3139L509.865 70.3134L508.349 76.5642L506.981 82.217H525.578V86.1657L532.222 92.8098L525.578 99.4538V108.105L532.222 114.757L525.578 121.401V130.053L532.222 136.697L525.578 143.341V151.992L532.222 158.636L525.578 165.288V173.939L532.222 180.583L525.578 187.227V195.895L532.222 202.539L525.578 209.191V213.206L524.758 212.386L523.226 213.918H525.61V217.867L532.254 224.519L525.586 231.122V239.774L532.23 246.418L525.586 253.062V261.713L532.23 268.365L525.586 275.009V283.66L532.23 290.304L525.586 296.949V305.592L532.23 312.236L525.586 318.888V327.539L532.23 334.183L525.586 340.827V349.478L532.23 356.122L525.586 362.766V371.418L532.23 378.07L525.586 384.714V393.332L532.23 399.976L525.586 406.62V415.272L532.23 421.916L525.586 428.568V437.219L532.23 443.863L525.586 450.507V459.158L532.23 465.803L525.586 472.455V481.098L532.23 487.75L525.586 494.394V503.111L532.23 509.755L525.586 516.399V525.05L532.23 531.702L525.586 538.338V546.989L529.207 550.61H533.844L525.889 542.664L534.548 534.004L542.389 541.853V537.224L536.859 531.694L542.389 526.156V521.527L534.548 529.327L525.889 520.667L534.548 512.016L542.389 519.864V515.227L536.859 509.697L542.389 504.168V499.531L534.548 507.379L525.889 498.728L534.548 490.077L542.389 497.917V493.28L536.859 487.75L542.389 482.22V477.583L534.548 485.432L525.889 476.772L534.548 468.121L542.389 475.969V471.332L536.859 465.803L542.389 460.273V455.677L534.548 463.517L525.889 454.866L534.548 446.214L542.389 454.055V449.426L536.859 443.896L542.389 438.366V433.729L534.548 441.578L525.889 432.926L534.548 424.267L542.389 432.115V427.478L536.859 421.948L542.389 416.419V411.79L534.548 419.638L525.889 410.979L534.548 402.344L542.389 410.192V405.539L536.859 400.009L542.389 394.479V389.842L534.548 397.691L525.889 389.04L534.548 380.38L542.389 388.228V383.6L536.859 378.07L542.389 372.54V367.936L534.548 375.784L525.889 367.117L534.548 358.465L542.389 366.314V361.677L536.859 356.147L542.389 350.617V345.98L534.548 353.829L525.889 345.177L534.548 336.526L542.389 344.366V339.738L536.859 334.208L542.389 328.678V324.041L534.548 331.889L525.889 323.238L534.548 314.579L542.389 322.427V317.79L536.859 312.227L542.389 306.697V302.069L534.548 309.917L525.889 301.258L534.548 292.607L542.389 300.455V295.843L536.859 290.313L542.389 284.783V280.146L534.548 287.994L525.889 279.343L534.548 270.684L542.389 278.532V273.887L536.859 268.357L542.389 262.819V258.157L534.548 266.006L525.889 257.346L534.548 248.695L542.389 256.544V251.907L536.859 246.377L542.389 240.847V236.21L534.548 244.058L525.889 235.407L534.548 226.756L542.389 234.596V229.967L536.859 224.437L542.389 218.908V214.271L534.548 222.119L525.889 213.46L534.548 204.808L542.389 212.657V208.02L536.859 202.49L542.389 196.96V192.331L534.548 200.171L525.889 191.553L534.548 182.902L542.389 190.742V186.113L536.859 180.583L542.389 175.053V170.417L534.548 178.265L525.889 169.614L534.548 160.954L542.389 168.803V164.166L536.859 158.636L542.389 153.106V148.477L534.548 156.326L525.889 147.666L534.548 139.015L542.389 146.863V142.226L536.859 136.697L542.389 131.167V126.53L534.548 134.378L525.889 125.727L534.548 117.068L542.389 124.916V120.287L536.859 114.79L542.389 109.26V104.623L534.548 112.472L525.889 103.812L534.548 95.1282L542.389 102.977V98.3397L536.859 92.8098L542.389 87.2799V82.643L534.548 90.4913L526.266 82.217H554.89V68.4291ZM527.339 19.1599L527.814 17.2101H549.934V44.1304H521.26L527.339 19.1599ZM522.424 64.0626C522.424 61.8849 523.069 59.7561 524.279 57.9454C525.489 56.1347 527.209 54.7235 529.221 53.8901C531.233 53.0567 533.446 52.8387 535.582 53.2635C537.718 53.6884 539.68 54.737 541.22 56.2769C542.76 57.8168 543.808 59.7787 544.233 61.9145C544.658 64.0504 544.44 66.2642 543.607 68.2762C542.773 70.2881 541.362 72.0077 539.551 73.2176C537.741 74.4274 535.612 75.0732 533.434 75.0732C530.519 75.0667 527.726 73.9035 525.667 71.8391C523.609 69.7747 522.454 66.9778 522.456 64.0626H522.424ZM557.299 61.3509L554.841 63.8086V58.8932L557.299 61.3509Z",
    fill: "#4B4B4B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M533.467 75.0732C539.548 75.0732 544.478 70.1436 544.478 64.0626C544.478 57.9816 539.548 53.052 533.467 53.052C527.386 53.052 522.456 57.9816 522.456 64.0626C522.456 70.1436 527.386 75.0732 533.467 75.0732Z",
    fill: "#666666"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M542.388 82.217V550.627H548.639V82.217H542.388ZM542.823 213.869L544.355 212.337L545.887 213.869H542.823Z",
    fill: "#666666"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M544.355 212.337L542.823 213.869H545.887L544.355 212.337Z",
    fill: "#4B4B4B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M535.245 550.586H539.882L542.389 548.079V543.442L535.245 550.586Z",
    fill: "#4B4B4B"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M525.586 538.314V525.017V516.366V505.896V503.078V494.427V481.131V477.182V472.488V459.191V450.54V437.252V428.601V415.304V406.653V393.365V384.714V374.236V371.418V362.766V349.478V345.53V340.827V327.539V318.888V305.592V296.94V283.652V275.001V261.705V253.054V242.584V239.765V231.114V217.818V213.869H523.202L524.734 212.337L525.586 213.189V209.167V195.879V187.227V173.939V165.288V151.992V143.341V130.053V121.401V108.105V99.4539V86.1658V82.217H519.335V213.869V242.584V345.53V374.236V477.182V505.896V550.586H525.586V546.965V538.314Z",
    fill: "#666666"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M378.221 172.276L430.308 140.154L482.395 172.276H378.221Z",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M423.574 135.066C423.574 136.398 423.969 137.7 424.709 138.807C425.449 139.915 426.5 140.778 427.731 141.288C428.961 141.797 430.315 141.931 431.622 141.671C432.928 141.411 434.128 140.77 435.07 139.828C436.012 138.886 436.653 137.686 436.913 136.38C437.173 135.074 437.039 133.72 436.53 132.489C436.02 131.259 435.157 130.207 434.049 129.467C432.942 128.727 431.64 128.332 430.308 128.332V123.212",
    stroke: "#666666",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M434.937 121.311H425.671V125.113H434.937V121.311Z",
    fill: "#4B4B4B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M438.599 117.51H422.026V121.311H438.599V117.51Z",
    fill: "#4B4B4B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M434.937 80.0295H425.671V83.8308H434.937V80.0295Z",
    fill: "#4B4B4B"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M438.599 76.2366H422.026V80.0379H438.599V76.2366Z",
    fill: "#4B4B4B"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M432.626 83.8311H428.039V117.51H432.626V83.8311Z",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    x: 359.509,
    y: 178.15,
    width: 137.239,
    height: 116.005,
    fill: "url(#pattern1_2157_8690)"
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M487.065 162.584H368.906C367.788 162.584 366.882 163.49 366.882 164.608V261.467C366.882 262.585 367.788 263.491 368.906 263.491H487.065C488.183 263.491 489.089 262.585 489.089 261.467V164.608C489.089 163.49 488.183 162.584 487.065 162.584Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M489.097 171.072V164.6C489.095 164.065 488.881 163.552 488.501 163.174C488.122 162.797 487.609 162.584 487.073 162.584H368.906C368.371 162.584 367.857 162.797 367.478 163.174C367.099 163.552 366.884 164.065 366.882 164.6V171.072H489.097Z",
    fill: "#666666"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M371.413 168.918C372.566 168.918 373.502 167.982 373.502 166.829C373.502 165.675 372.566 164.74 371.413 164.74C370.259 164.74 369.324 165.675 369.324 166.829C369.324 167.982 370.259 168.918 371.413 168.918Z",
    fill: "#C1272D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M380.605 166.828C380.61 167.243 380.491 167.649 380.264 167.996C380.037 168.343 379.712 168.615 379.33 168.776C378.949 168.938 378.527 168.983 378.12 168.904C377.713 168.826 377.339 168.628 377.044 168.336C376.75 168.044 376.549 167.671 376.468 167.264C376.386 166.858 376.427 166.436 376.586 166.053C376.744 165.67 377.013 165.343 377.358 165.114C377.704 164.884 378.109 164.762 378.524 164.764C379.073 164.764 379.6 164.981 379.989 165.367C380.379 165.754 380.6 166.279 380.605 166.828Z",
    fill: "#FBB03B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M385.635 168.918C386.788 168.918 387.724 167.982 387.724 166.829C387.724 165.675 386.788 164.74 385.635 164.74C384.481 164.74 383.546 165.675 383.546 166.829C383.546 167.982 384.481 168.918 385.635 168.918Z",
    fill: "#8CC63F"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M489.089 171.072H366.882V183.271H489.089V171.072Z",
    fill: "#CFD1D9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 174.177H376.787V180.633H407.402V174.177Z",
    fill: "#AEB8BF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 174.177H412.678V180.633H443.293V174.177Z",
    fill: "#AEB8BF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 174.177H448.577V180.633H479.192V174.177Z",
    fill: "#AEB8BF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 190.087H376.787V210.715H407.402V190.087Z",
    fill: "#446B34"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 190.087H412.678V210.715H443.293V190.087Z",
    fill: "#9C9E4C"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 190.087H448.577V210.715H479.192V190.087Z",
    fill: "#FFBD4F"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 214.606H376.787V216.245H407.402V214.606Z",
    fill: "#AEB8BF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 218.891H376.787V220.529H407.402V218.891Z",
    fill: "#AEB8BF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 223.168H376.787V224.806H407.402V223.168Z",
    fill: "#AEB8BF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 214.606H412.678V216.245H443.293V214.606Z",
    fill: "#AEB8BF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 218.891H412.678V220.529H443.293V218.891Z",
    fill: "#AEB8BF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 223.168H412.678V224.806H443.293V223.168Z",
    fill: "#AEB8BF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 214.606H448.577V216.245H479.192V214.606Z",
    fill: "#AEB8BF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 218.891H448.577V220.529H479.192V218.891Z",
    fill: "#AEB8BF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 223.168H448.577V224.806H479.192V223.168Z",
    fill: "#AEB8BF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 228.763H376.787V249.392H407.402V228.763Z",
    fill: "#76ABD5"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 228.763H412.678V249.392H443.293V228.763Z",
    fill: "#FFBD4F"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 228.763H448.577V249.392H479.192V228.763Z",
    fill: "#446B34"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 253.275H376.787V254.913H407.402V253.275Z",
    fill: "#AEB8BF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M407.402 257.56H376.787V259.198H407.402V257.56Z",
    fill: "#AEB8BF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 253.275H412.678V254.913H443.293V253.275Z",
    fill: "#AEB8BF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M443.293 257.56H412.678V259.198H443.293V257.56Z",
    fill: "#AEB8BF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 253.275H448.577V254.913H479.192V253.275Z",
    fill: "#AEB8BF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M479.192 257.56H448.577V259.198H479.192V257.56Z",
    fill: "#AEB8BF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M175.671 405.457H163.677V428.502H175.671V405.457Z",
    fill: "#99BFB2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M492.448 405.457H198.889V428.502H492.448V405.457Z",
    fill: "#99BFB2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 231.969,
    y: 66.7004,
    width: 100.668,
    height: 87.2984,
    fill: "url(#pattern2_2157_8690)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M325.191 51.1348H239.343V123.425H325.191V51.1348Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M286.785 58.4751H244.143V61.0147H286.785V58.4751Z",
    fill: "#AEB8BF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M286.785 66.6189H244.143V69.1586H286.785V66.6189Z",
    fill: "#AEB8BF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M286.785 74.762H244.143V77.3016H286.785V74.762Z",
    fill: "#AEB8BF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M320.947 82.9053H244.143V85.4449H320.947V82.9053Z",
    fill: "#AEB8BF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M320.947 91.0486H244.143V93.5882H320.947V91.0486Z",
    fill: "#AEB8BF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M320.947 99.2002H244.143V101.74H320.947V99.2002Z",
    fill: "#AEB8BF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M320.947 107.343H244.143V109.883H320.947V107.343Z",
    fill: "#AEB8BF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M320.947 115.486H244.143V118.026H320.947V115.486Z",
    fill: "#AEB8BF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M320.947 58.4751H290.971V77.588H320.947V58.4751Z",
    fill: "#FFBD4F"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M235.541 65.6765H231.74V74.9421H235.541V65.6765Z",
    fill: "#4B4B4B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M239.343 62.031H235.541V78.6043H239.343V62.031Z",
    fill: "#4B4B4B"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M231.74 68.0442H222.638V72.6319H231.74V68.0442Z",
    fill: "#666666"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M332.794 65.6765H328.992V74.9421H332.794V65.6765Z",
    fill: "#4B4B4B"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M328.992 62.031H325.191V78.6043H328.992V62.031Z",
    fill: "#4B4B4B"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M341.895 68.0442H332.794V72.6319H341.895V68.0442Z",
    fill: "#666666"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M227.226 -4H222.638V72.4435H227.226V-4Z",
    fill: "#666666"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M341.928 -4H337.34V72.4435H341.928V-4Z",
    fill: "#666666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2157_8690",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2157_8690",
    transform: "scale(0.00286533 0.00338983)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2157_8690",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2157_8690",
    transform: "scale(0.00286533 0.00338983)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_2157_8690",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2157_8690",
    transform: "scale(0.00390625 0.0045045)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2157_8690",
    width: 349,
    height: 295,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2157_8690",
    width: 256,
    height: 222,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskChecker);
export default __webpack_public_path__ + "static/media/riskChecker.448ff1eecd0d298df240ec21a64f1052.svg";
export { ForwardRef as ReactComponent };